export default "__VITE_ASSET__gytzrntB__"